import { AccessPermissions } from '@circlefin/permissions'
import { Role } from '@circlefin/permissions/roles'
import { SynthRole } from '@services/synthetic-roles'

import type { PermissionSet } from '@circlefin/permissions'

/**
 * Permissions for enabling stripe.
 */
export const STRIPE_ENABLED: PermissionSet = {
  access: AccessPermissions.protected,
  includeAny: [
    Role.BILLING_DASHBOARD_ROLE,
    Role.ACCOUNT_DASHBOARD_MANAGEMENT_ROLE,
  ],
  includeAll: [SynthRole.SYNTH_STRIPE_ENABLE_ROLE],
  excludeAny: [Role.DEVELOPER_BILLING_ROLE],
}
